import { animate as motionAnimate, scroll } from './vendor.min.js';

class FeaturedList extends HTMLElement {
  connectedCallback() {
    this.viewButtonElement = this.querySelector('[data-action="toggle-featured-list"]');
    this.featuredListListings = this.querySelector(".featured-list__listing");
    this.featuredListListingsHeight = this.featuredListListings.clientHeight;
    this.featuredListItems = Array.from(this.featuredListListings.children);
    this.featuredListDisplayRows = this.getAttribute("max-rows");
    if (this.viewButtonElement) {
      this.viewButtonElement.addEventListener("click", this._toggleRows.bind(this));
    }
  }

  _toggleRows() {
    if (this.classList.contains("is-expanded")) {
      this._hideRows();
    } else {
      this._showRows();
    }
  }

  async _showRows() {
    const fromHeight = this.featuredListListings.clientHeight;
    this.featuredListItems.forEach(row => row.hidden = false);
    this.viewButtonElement.querySelector(".featured-list__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-less");
    this.classList.add("is-expanded");

    await motionAnimate(this.featuredListListings, {
      height: [`${fromHeight}px`, `${this.featuredListListings.scrollHeight}px`]
    }).finished;

    this.featuredListListings.style.height = "auto";
  }

  async _hideRows() {
    const fromHeight = this.featuredListListings.clientHeight;
    let toHeight = this.featuredListListingsHeight;
    this.viewButtonElement.querySelector(".featured-list__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-more");
    this.classList.remove("is-expanded");

    await motionAnimate(this.featuredListListings, {
      height: [`${fromHeight}px`, `${toHeight}px`]
    }).finished;

    this.featuredListItems.slice(parseInt(this.featuredListDisplayRows)).forEach(row => row.hidden = true);
    this.featuredListListings.style.height = "auto";
  }
}

if (!window.customElements.get("featured-list")) {
  window.customElements.define("featured-list", FeaturedList);
}
